import { useCallback, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Swal from 'sweetalert2'
import { useTranslation } from 'react-i18next'

import i18n from '@/i18n'
import ExpenseForm from '../common/ExpenseForm'
import ExpensesService from '@/services/ExpensesService'
import LoadingIndicator from '@/widgets/LoadingIndicator'

const LOAD_FAILED_KEY = 'expenses.edit.messages.loadFailed'
const UPDATE_FAILED_KEY = 'expenses.edit.messages.updateFailed'

export default function ExpenseEdit() {
	const { t } = useTranslation()
	const { id } = useParams()
	const navigate = useNavigate()
	const [expense, setExpense] = useState(null)
	const [loading, setLoading] = useState(true)
	const [submitting, setSubmitting] = useState(false)

	const loadExpense = useCallback(async () => {
		setLoading(true)
		const { data, error } = await ExpensesService.getExpenseById(id)
		if (error) {
			Swal.fire(i18n.t('expenses.list.messages.errorTitle'), error || i18n.t(LOAD_FAILED_KEY), 'error')
			navigate('/ksiegowosc/expenses')
			return
		}
		// remove unnecessary fields
		delete data.created
		delete data.__v
		delete data._id
		setExpense(data)
		setLoading(false)
	}, [id, navigate])

	useEffect(() => {
		if (id) loadExpense()
	}, [id, loadExpense])

	const handleSubmit = async payload => {
		if (submitting) return
		setSubmitting(true)
		const result = await ExpensesService.updateExpense(id, payload)
		if (!result.success) {
			Swal.fire(i18n.t('expenses.list.messages.errorTitle'), result.error || i18n.t(UPDATE_FAILED_KEY), 'error')
			setSubmitting(false)
			return
		}
		navigate(`/ksiegowosc/expenses/details/${id}`)
		setSubmitting(false)
	}

	if (loading) return <LoadingIndicator message={t('expenses.edit.loading')} />

	return (
		<div className="max-w-6xl mx-auto px-0 sm:px-6 lg:px-8">
			<div className="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl">
				<div className="px-4 sm:px-6 py-6 border-b border-gray-200">
					<h1 className="text-2xl font-bold text-gray-900">{t('expenses.edit.title')}</h1>
				</div>

				<div className="px-4 sm:px-6 py-6">
					<ExpenseForm
						mode="edit"
						initialData={expense}
						onSubmit={handleSubmit}
						onCancel={() => navigate('/ksiegowosc/expenses')}
						submitting={submitting}
					/>
				</div>
			</div>
		</div>
	)
}
